import React from 'react';
import {Flex} from '/app/src/component';

class ModalTemplate extends React.Component {
    render() {
        const bgColor = '#2EA2D2'
        const {children, header} = this.props
        return <Flex width='800px' height='550px' borderRadius='20px' column>
            <Flex width='100%' height='60px' bg={bgColor}>
                {header}
            </Flex>
            <Flex grow>
                {children}
            </Flex>
        </Flex>
    }

}

export default ModalTemplate;



// WEBPACK FOOTER //
// ./src/component/Modal/PaymentModal/ModalTemplate.js